module.exports = __webpack_public_path__ + "img/horizontal_2_1_r_3009.eb972668.png";